import { CheckoutService } from './checkout.service';
import { OloPayService } from './olo-pay.service';

export const services = [CheckoutService, OloPayService];

export * from './checkout.service';
export * from './olo-pay.service';
